import React from 'react';
import GooglePlayStoreIcon from './Icon';

const GooglePlayStoreButton = () => (
  <a href="https://play.google.com/store/apps/details?id=com.mydrivingacademy.mittkorkort" target="_blank" rel="noreferrer">
    <GooglePlayStoreIcon />
  </a>
)

export default GooglePlayStoreButton;